import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import {
  DataTable,
  SearchPropTypes,
  CompanyName,
  NoteTooltipTableCell,
  LocationFlag
} from "MODULES/shared/components";
import { shortDateYYandTime } from "LIB/formatters/date";
import { LOT_TYPES } from "MODULES/Lots/constants";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { CONDITIONS } from "MODULES/Shipping/constants";
import classNames from "classnames";

function renderRow(r, pushHistory) {
  const remainingCost = r.cost - r.applied_cost;
  return (
    <tr
      key={r.id}
      className={classNames("clickable", { "text-muted": r.cancelled })}
      onClick={() => pushHistory(`/lots/${r.uuid}`)}
    >
      <td>{r.code}</td>
      <td>{shortDateYYandTime(r.created_at)}</td>
      <td>{shortDateYYandTime(r.date_received)}</td>
      <td>
        {r.company && <CompanyName company={r.company} truncateAt={20} />}
      </td>
      <td>{r.buyer && getFirstNameLastInitial(r.buyer.full_name)}</td>
      <td>{r.co_buyer && getFirstNameLastInitial(r.co_buyer.full_name)}</td>
      <td>
        {r.third_buyer && getFirstNameLastInitial(r.third_buyer.full_name)}
      </td>
      <MultiLocationFeature>
        <th>{<LocationFlag location={r.buying_store_id} />}</th>
      </MultiLocationFeature>
      <td>{r.name}</td>
      <td>{LOT_TYPES[r.lot_type].label}</td>
      <td>{r.condition && CONDITIONS[r.condition].label}</td>
      <td>{r.reference_number}</td>
      <td>{r.lead_time}</td>
      <td className="text-right">{dollars(r.original_cost)}</td>
      <td>{dollars(remainingCost < 0 ? 0 : remainingCost)}</td>
      <td className="text-center">{r.quantity}</td>

      <NoteTooltipTableCell note={r.last_lot_note} />
    </tr>
  );
}

export function Table({ pushHistory, isLoading, pageActions, results }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>LO #</th>
        <th>Created At</th>
        <th>Date Received</th>
        <th className="text-center">Vendor</th>
        <th>Buyer</th>
        <th>Co-Buyer</th>
        <th>Third Buyer</th>
        <MultiLocationFeature>
          <th>Store Owner</th>
        </MultiLocationFeature>
        <th>Lot Name</th>
        <th>Lot Type</th>
        <th className="text-center">CD</th>
        <th>Ref #</th>
        <th>LT</th>
        <th className="text-right">Original Cost</th>
        <th>Remaining Cost</th>
        <th className="text-center">QTY</th>
        <th>Note</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/Lots/Search/Table.jsx